import { render, staticRenderFns } from "./ComssionFull.vue?vue&type=template&id=6de9dcb0&scoped=true"
import script from "./ComssionFull.vue?vue&type=script&lang=js"
export * from "./ComssionFull.vue?vue&type=script&lang=js"
import style0 from "./ComssionFull.vue?vue&type=style&index=0&id=6de9dcb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de9dcb0",
  null
  
)

export default component.exports
import QForm from 'quasar/src/components/form/QForm.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QSpace from 'quasar/src/components/space/QSpace.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QForm,QDialog,QCard,QCardSection,QSeparator,QBtn,QInput,QSelect,QTooltip,QCardActions,QTable,QTd,QChip,QSpace});qInstall(component, 'directives', {ClosePopup});
